import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Loader2 } from 'lucide-react';
import { useAlbumNavigation } from "@/hooks/useAlbumNavigation";
import { useAlbumContext } from '@/contexts/AlbumProvider';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const { getAlbumPath } = useAlbumNavigation();
  const { loading: albumLoading } = useAlbumContext();
  const location = useLocation();

  if (loading || albumLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center space-y-4">
          <Loader2 className="w-8 h-8 animate-spin mx-auto text-primary" />
          <p className="text-muted-foreground">Verificando autenticación...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    const currentUrl = `${location.pathname}${location.search}`;
    const loginPath = getAlbumPath("/login");
    return <Navigate to={`${loginPath}?redirect=${encodeURIComponent(currentUrl)}`} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;